export default function EntityStatus({
  deletedAt,
}: {
  deletedAt?: string | null;
}) {
  return deletedAt ? (
    <span className="statusBadge statusBadgeEnded">Deactivated</span>
  ) : null;
}
